
import request from '@/utils/request'
const general_adress = process.env.VUE_APP_GENERAL_API_HOST

export function getMemberBindTrendApi(days) {
  return request({
    url: '?c=rms&a=member&do=trend',
    method: 'get',
    params: {
      days: days
    }
  })
}

export function getEquipRankApi(params) {
  return request({
    url: '?c=rms&a=member&do=num-rank',
    method: 'get',
    params
  })
}

export function getActiveMemberApi(params) {
  return request({
    url: '?c=rms&a=member&do=active-rank',
    method: 'get',
    params
  })
}

export function getRecentBindApi(params) {
  return request({
    url: '?c=rms&a=member&do=new-bind',
    method: 'get',
    params
  })
}

export function setRmsFlagMember(data) {
  return request({
    url: '?c=rms&a=member_group&do=tagging',
    method: 'post',
    data
  })
}

export function setRmsRemarkApi(data) {
  return request({
    url: '?c=rms&a=member-profile&do=post',
    method: 'post',
    data
  })
}

export function addCollectionApi(data) {
  return request({
    url: general_adress + '/collection/add',
    method: 'post',
    data
  })
}

export function cancelCollectionApi(data) {
  return request({
    url: general_adress + '/collection/cancel',
    method: 'post',
    data
  })
}

export function proOptionsApi(params) {
  return request({
    url: general_adress + "/ei/pro/getOptions",
    method: "get",
    params
  });
}

export function preorderApi(data) {
  return request({
    url: general_adress + "/ei/pro/preorder",
    method: "post",
    data
  });
}